import { render } from "./BasicView.vue?vue&type=template&id=7dc38871&scoped=true"
const script = {}

import "../assets/general.css?vue&type=style&index=0&id=7dc38871&scoped=true&lang=css&external"
/* custom blocks */
import block0 from "./BasicView.vue?vue&type=custom&index=0&blockType=route&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc38871"]])

export default __exports__